import { Controller } from "@hotwired/stimulus"

// Keeps the element scrolled to the bottom on load and when new children arrive.
export default class extends Controller {
  connect() {
    this.scroll()
    this.observer = new MutationObserver(() => this.scroll())
    this.observer.observe(this.element, { childList: true })
  }

  disconnect() {
    this.observer?.disconnect()
  }

  scroll() {
    this.element.scrollTop = this.element.scrollHeight
  }
}
